import { INPUT_TYPE } from "../constants";

export const CREATE_MOVIE_CONFIGS = [
  {
    fieldName: "title",
    label: "title",
    inputType: INPUT_TYPE.TEXT,
  },
  {
    fieldName: "description",
    label: "description",
    inputType: INPUT_TYPE.TEXT_AREA,
  },
  {
    fieldName: "type",
    label: "type",
    enumValues: ["", "动漫", "电影", "儿童", "电视剧"],
    inputType: INPUT_TYPE.SELECT,
  },
];

const CURRENCIES_LIST = [
  { currencyName: "🇺🇸 United States Dollar", currencyCode: "USD", sign: "$" },
  { currencyName: "🇪🇺 Euro", currencyCode: "EUR", sign: "€" },
  { currencyName: "🇯🇵 Japanese Yen", currencyCode: "JPY", sign: "¥" },
  { currencyName: "🇬🇧 British Pound Sterling", currencyCode: "GBP", sign: "£" },
  { currencyName: "🇦🇺 Australian Dollar", currencyCode: "AUD", sign: "$" },
  { currencyName: "🇨🇦 Canadian Dollar", currencyCode: "CAD", sign: "$" },
  { currencyName: "🇨🇭 Swiss Franc", currencyCode: "CHF", sign: "CHF" },
  { currencyName: "🇨🇳 Chinese Yuan Renminbi", currencyCode: "CNY", sign: "¥" },
  { currencyName: "🇸🇪 Swedish Krona", currencyCode: "SEK", sign: "kr" },
  { currencyName: "🇳🇿 New Zealand Dollar", currencyCode: "NZD", sign: "$" },
  { currencyName: "🇲🇽 Mexican Peso", currencyCode: "MXN", sign: "$" },
  { currencyName: "🇸🇬 Singapore Dollar", currencyCode: "SGD", sign: "$" },
  { currencyName: "🇭🇰 Hong Kong Dollar", currencyCode: "HKD", sign: "$" },
  { currencyName: "🇳🇴 Norwegian Krone", currencyCode: "NOK", sign: "kr" },
  { currencyName: "🇰🇷 South Korean Won", currencyCode: "KRW", sign: "₩" },
  { currencyName: "🇹🇷 Turkish Lira", currencyCode: "TRY", sign: "₺" },
  { currencyName: "🇮🇳 Indian Rupee", currencyCode: "INR", sign: "₹" },
  { currencyName: "🇷🇺 Russian Ruble", currencyCode: "RUB", sign: "₽" },
  { currencyName: "🇧🇷 Brazilian Real", currencyCode: "BRL", sign: "R$" },
  { currencyName: "🇿🇦 South African Rand", currencyCode: "ZAR", sign: "R" },
  { currencyName: "🇩🇰 Danish Krone", currencyCode: "DKK", sign: "kr" },
  { currencyName: "🇵🇱 Polish Zloty", currencyCode: "PLN", sign: "zł" },
  { currencyName: "🇮🇱 Israeli New Shekel", currencyCode: "ILS", sign: "₪" },
  { currencyName: "🇹🇭 Thai Baht", currencyCode: "THB", sign: "฿" },
  { currencyName: "🇮🇩 Indonesian Rupiah", currencyCode: "IDR", sign: "Rp" },
  { currencyName: "🇭🇺 Hungarian Forint", currencyCode: "HUF", sign: "Ft" },
  { currencyName: "🇨🇿 Czech Koruna", currencyCode: "CZK", sign: "Kč" },
  { currencyName: "🇲🇾 Malaysian Ringgit", currencyCode: "MYR", sign: "RM" },
  { currencyName: "🇵🇭 Philippine Peso", currencyCode: "PHP", sign: "₱" },
  { currencyName: "🇨🇴 Colombian Peso", currencyCode: "COP", sign: "$" },
  { currencyName: "🇷🇴 Romanian Leu", currencyCode: "RON", sign: "lei" },
  { currencyName: "🇸🇦 Saudi Riyal", currencyCode: "SAR", sign: "﷼" },
  { currencyName: "🇦🇪 United Arab Emirates Dirham", currencyCode: "AED", sign: "د.إ" },
  { currencyName: "🇻🇳 Vietnamese Dong", currencyCode: "VND", sign: "₫" },
  { currencyName: "🇳🇬 Nigerian Naira", currencyCode: "NGN", sign: "₦" },
  { currencyName: "🇦🇷 Argentine Peso", currencyCode: "ARS", sign: "$" },
  { currencyName: "🇨🇱 Chilean Peso", currencyCode: "CLP", sign: "$" },
  { currencyName: "🇪🇬 Egyptian Pound", currencyCode: "EGP", sign: "£" },
  { currencyName: "🇰🇼 Kuwaiti Dinar", currencyCode: "KWD", sign: "د.ك" },
  { currencyName: "🇶🇦 Qatari Riyal", currencyCode: "QAR", sign: "﷼" },
];

export const CREATE_EXPENSE_CONFIGS = [
  {
    fieldName: "title",
    label: "title",
    inputType: INPUT_TYPE.TEXT,
  },
  {
    fieldName: "description",
    label: "description",
    inputType: INPUT_TYPE.TEXT_AREA,
  },
  {
    fieldName: "total",
    label: "total",
    inputType: INPUT_TYPE.NUMBER,
  },
  {
    fieldName: "bulkAddItemStr",
    label: "bulkAdd",
    inputType: INPUT_TYPE.TEXT_AREA,
  },
  {
    fieldName: "purchasedDate",
    label: "purchasedDate",
    inputType: INPUT_TYPE.DATE,
    required: true,
  },
  {
    fieldName: "currency",
    label: "currency",
    inputType: INPUT_TYPE.SELECT,
    enumValues: CURRENCIES_LIST.map((item) => ({ name: item.currencyName, value: item.currencyCode })),
  },
];

export const CREATE_EXPENSE_CONFIGS_WITHOUT_BULK = CREATE_EXPENSE_CONFIGS.filter(
  (ite) => ite.fieldName !== "bulkAddItemStr"
);
